import { autoserialize } from 'cerialize';

export class TransitProgramInfo {

  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  timeZone: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  active: boolean;

}
